<!-- Name -->
@if ((showSkeleton$() | async)) {
  <div class="flex py-2 align-items-center justify-content-between" data-testid="client-info-skeleton">
    <p-skeleton styleClass="w-2rem h-2rem border-circle" />
    <p-skeleton styleClass="w-5rem mx-2" height="1.35rem" />
    <p-skeleton styleClass="w-4rem" height="1.35rem" />
  </div>
}

@if ((showSkeleton$() | async) === false && planSummary$(); as planSummary;) {
  <div
    class="flex align-items-center justify-content-between" data-testid="client-info-container">
    <div class="flex align-items-center line-height-1">
      <div class="h-2rem w-2rem hidden md:block">
        @if (clientData && clientData.client_image) {
          <p-avatar [image]="clientData.client_image" shape="circle" aria-label="client-avatar" data-testid="client-avatar" />
        } @else {
          <p-avatar [label]="planSummary.client.client_name | titlecase | shortName" shape="circle"
          aria-label="client-initials" data-testid="client-initials-avatar" />
        }
      </div>
      <div class="mb-0 md:ml-2 flex align-items-center">
        <div>
          <span
            class="block max-w-7rem md:max-w-11rem overflow-hidden text-overflow-ellipsis white-space-nowrap text-primary text-sm mr-1 md:mr-2 font-bold border-bottom-1 border-white"
            aria-label="View client profile" data-testid="client-profile-link">
            {{ planSummary.client.client_name }}
          </span>
          @if ((billingName !=='' && billingName !== null && billingName !== undefined) || (planSummary.billingName !=='' && planSummary.billingName !== null && planSummary.billingName !== undefined)) {
            <div class="position-absolute text-xs text-600 mb-0 w-9 white-space-nowrap text-overflow-ellipsis" data-testid="billing-name-display">
              <strong>{{ 'POS.MEMBERSHIP_ADDON.BILLING_NAME' | translate }} :</strong> {{ billingName || planSummary.billingName }}
              <span class="fa fa-times text-xl text-600 cursor-pointer"
                (click)="removeBillingName()" aria-label="remove-billing-name" data-testid="remove-billing-name-button">
              </span>
            </div>
          }
        </div>
        <!-- <span class="text-600 font-normal text-sm hidden md:flex mt-1">
        {{'common.DATA.CLIENT_ID' | translate}} - {{planSummary.client.client_id}}
      </span> -->
      <span class="text-600 font-normal text-sm mr-2" data-testid="client-id">
        - {{planSummary.client.client_id}}
      </span>
    </div>
  </div>
  <div class="flex align-items-center justify-content-end absolute right-0 mr-3">
    <!-- <div [innerHTML]="clientStatus( planSummary.client)"></div> -->
    <button pButton pRipple type="button" icon="fa fa-ellipsis-h"
      class="surface-0 p-button-outlined border-300 ml-2 text-xs md:text-sm p-1 md:p-2 h-2rem w-2rem text-600"
    (click)="action.toggle($event)" aria-label="client-actions" data-testid="client-actions-button"></button>
    <p-popover #action styleClass="overflow-hidden right-0 text-sm w-10rem -ml-3" aria-label="client-actions-menu" data-testid="client-actions-panel">
      <ng-template #content>
        <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
          <li class="cursor-pointer hover:surface-300 p-3 flex align-items-center"
            (click)="showChangeBillingNameModel$.next(true)" data-testid="edit-billing-name-option" aria-label="edit billing name"><i
          class="fa fa-user-edit text-xs mr-2"></i>{{'POS.MEMBERSHIP_ADDON.EDIT_BILLING_NAME' | translate}}
        </li>
      </ul>
    </ng-template>
  </p-popover>
</div>
</div>
}
<!-- Name -->


@if (showChangeBillingNameModel$ | async) {
  <change-billling-name [visible]="showChangeBillingNameModel$ | async"  [removeName]="isRemoveBillingName"
    (closeChangeBillingNameDialogEvent)="closeChangeBillingNameDialogEvent($event)" data-testid="change-billing-name-component" />
}